import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface PlaybookRootNodeData {
  label?: string;
  version?: string;
  // Add other playbook-level properties if needed
}

const PlaybookRootNode: React.FC<NodeProps<PlaybookRootNodeData>> = ({ data }) => {
  const label = data?.label || 'Playbook';
  const version = data?.version || 'N/A';

  return (
    <div className="playbook-node playbook-root-node" style={{ width: 200 }}>
      <div className="playbook-node-header">
        <strong>{label}</strong>
        <span className="playbook-node-version">v{version}</span>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555' }}>
        (Entry Point)
      </div>
      {/* Single source handle for connecting to global/event-specific nodes */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        style={{ background: '#555' }}
      />
    </div>
  );
};

export default PlaybookRootNode;
